'use strict';

// dom
const {
	h1, a, div, header, p,
	section, button, span, ul, li
} = require('iblokz-snabbdom-helpers');

// crud
const list = require('./list');
const edit = require('./edit');

module.exports = ({state, actions, i18n}) => div('.admin-resources', [].concat(
	!state.router.pageId
		? list({state, actions, i18n})
		: edit({state, actions, i18n})
));
